import { render, staticRenderFns } from "./OneOneCourse.vue?vue&type=template&id=790fcf1e&scoped=true&"
import script from "./OneOneCourse.vue?vue&type=script&lang=js&"
export * from "./OneOneCourse.vue?vue&type=script&lang=js&"
import style0 from "./OneOneCourse.vue?vue&type=style&index=0&id=790fcf1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790fcf1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VDataTable,VRow,VTab,VTabs})
